import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NotificationService } from 'src/app/services/notification.service';
import { Organization } from 'src/typings';
import { OrgService } from '../org.service';

@Component({
  selector: 'app-org-selector',
  templateUrl: './org-selector.component.html',
  styleUrls: ['./org-selector.component.scss']
})
export class OrgSelectorComponent implements OnInit {
  constructor(private orgService: OrgService, private notificationService: NotificationService) {}

  orgs: Observable<{ data: Organization[]; length: number }> = this.orgService.search();

  filteredOptions: Observable<Observable<Organization[]>> = new Observable();

  value: any;

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  public displayProperty(org: any) {
    if (org) {
      return org.name;
    }
    return;
  }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: string | Organization): Observable<Organization[]> {
    const lowerValue = typeof value === 'string' ? value.toLowerCase() : value?.name.toLowerCase();

    return this.orgs.pipe(
      map((orgs) =>
        orgs.data.filter((org) => {
          if (!lowerValue) return true;
          return org.name.toLowerCase().includes(lowerValue);
        })
      )
    );
  }

  handleSelect(event: MatAutocompleteSelectedEvent) {
    if (typeof event.option.value === 'string') {
      this.orgService.create({ name: event.option.value }).subscribe((data) => {
        this.notificationService.notice(`Ориганизация "${data.name}" создана!`);
        this.control.setValue(data);
      });
    }
  }
}
